export const LS_TOKEN_KEY = 'accessToken';
export const PW_MIN_LENGTH = 8;
